@let tenant = this.tenant();
@if (tenant && tenant.portal) {
<div class="modal-content">
  <div class="modal-header">
    @if (tenant.id) {
    <h5 class="modal-title"> {{ 'EDIT' | translation }} {{ tenant.name }} ({{tenant.id}})</h5>
    } @else {
    <h5 class="modal-title">{{ 'TENANT_CREATE' | translation }}</h5>
    }
  </div>
  <div class="modal-body">
    <div class="mb-3 gap-2 d-md-block">
      <button class="btn btn-primary" type="button" (click)="showPage('nav')">
        {{ 'TENANT_NAV' | translation }}
      </button>
      <span class="p-2"></span>
      <button class="btn btn-primary" type="button" (click)="showPage('portal')">
        {{ 'TENANT_PAGE' | translation }}
      </button>
      <span class="p-2"></span>
      <button class="btn btn-primary" type="button" (click)="showPage('theme')">
        {{ 'TENANT_THEME' | translation }}
      </button>
    </div>

    @if (pageId === 'portal') {
    <div class="mb-3">
      <label>
        {{ 'URL_ROUTE' | translation }}
      </label>
      <input #portalroute type="text" class="form-control" [readonly]="tenant.id" [(ngModel)]="tenant.portal.route"
        (keyup)="validroute()" [ngClass]="{
              'is-invalid': !tenant.portal.route || tenant.portal.route.length === 0
            }" required />
    </div>

    <div class="mb-3">
      <label>{{ 'LOGIN_HEADING' | translation }}</label>
      <input [disabled]="!tenant.portal.route || tenant.portal.route.length === 0" type="text" class="form-control"
        [(ngModel)]="tenant.portal.loginHeading" />
    </div>

    <label>{{ 'LOGO' | translation }}</label>
    <div class="mb-3 input-group">
      <input type="file" class="file-input" (change)="onFileUploadChange($event)" accept=".jpg,.png,.gif" #fileUpload
        [multiple]="false" [hidden]="true" />
      <input type="text" class="form-control" readonly [(ngModel)]="tenant.portal.logo" />

      <button class="btn btn-outline-success" (click)="fileUpload.click()" type="button">
        <i class="ms-1 fa-solid fa-upload"></i>
      </button>
    </div>

    @if(cultures.length > 1) {
    <label>{{ 'TENANT_LANGUAGE' | translation }}</label>
    <div class="mb-3 input-group">
      <select class="form-control" #languageSelect [(ngModel)]="tenant.portal.locale">
        <option [ngValue]="null"></option>
        @for (languageOption of cultures; track $index) {
        <option [ngValue]="languageOption.language">{{ languageOption.name }}</option>
        }
      </select>
    </div>
    }
    <div class="mb-3">
      <label>{{ 'IDLE_TIMEOUT_MINUTES' | translation }}</label>
      <input type="number" min="0" class="form-control" [(ngModel)]="tenant.portal.idleTimeoutMinutes" />
      <div class="form-text">{{ 'IDLE_TIMEOUT_MINUTES_HELP' | translation }}</div>
    </div>
    @if (!environment.environment.startsWith('forsyning')) {
    <div class="mb-3 form-check form-switch">
      <input class="form-check-input" type="checkbox" id="passwordResetEnabledSwitch" [(ngModel)]="tenant.portal.passwordResetEnabled" />
      <label class="form-check-label ms-2" for="passwordResetEnabledSwitch">{{ 'PASSWORD_RESET_ENABLED' | translation }}</label>
      <div class="form-text">{{ 'PASSWORD_RESET_ENABLED_HELP' | translation }}</div>
    </div>
    }
    }
    @if (pageId === 'theme') {

    <label>{{ 'THEME_PALETTE' | translation }}</label>
    <div class="mb-3 d-flex flex-wrap gap-2">
      @for (theme of portalThemes; track theme.name) {
      <div class="theme-swatch" [class.theme-swatch--active]="tenant.portal.uiTheme === theme.name"
        (click)="selectPalette(theme)" [title]="theme.name" role="button">
        <div class="theme-swatch__colors">
          <div class="theme-swatch__color" [style.background-color]="theme.primary"></div>
          <div class="theme-swatch__color" [style.background-color]="theme.secondary"></div>
          <div class="theme-swatch__color" [style.background-color]="theme.background"></div>
        </div>
        <small class="theme-swatch__name">{{ theme.name }}</small>
      </div>
      }
    </div>

    <p class="small text-muted mb-1">{{ 'THEME_BRAND_COLORS' | translation }}</p>
    <div class="mb-3">
      <div class="row g-2">
        <div class="col-md-4">
          <label class="form-label">{{ 'THEME_PRIMARY' | translation }}</label>
          <div class="input-group">
            <input type="color" class="form-control form-control-color"
              [value]="tenant.portal.primaryColor || selectedPalette?.primary || '#24447f'"
              (input)="setPortalColor('primaryColor', $any($event.target).value)" />
            <button class="btn btn-outline-secondary" type="button" [title]="'CLEAR' | translation"
              (click)="clearPortalColor('primaryColor')">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <label class="form-label">{{ 'THEME_SECONDARY' | translation }}</label>
          <div class="input-group">
            <input type="color" class="form-control form-control-color"
              [value]="tenant.portal.secondaryColor || selectedPalette?.secondary || '#b6bbc2'"
              (input)="setPortalColor('secondaryColor', $any($event.target).value)" />
            <button class="btn btn-outline-secondary" type="button" [title]="'CLEAR' | translation"
              (click)="clearPortalColor('secondaryColor')">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <label class="form-label">{{ 'THEME_BACKGROUND' | translation }}</label>
          <div class="input-group">
            <input type="color" class="form-control form-control-color"
              [value]="tenant.portal.backgroundColor || selectedPalette?.background || '#edf1f6'"
              (input)="setPortalColor('backgroundColor', $any($event.target).value)" />
            <button class="btn btn-outline-secondary" type="button" [title]="'CLEAR' | translation"
              (click)="clearPortalColor('backgroundColor')">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <p class="small text-muted mb-1">{{ 'THEME_SEMANTIC_COLORS' | translation }}</p>
    <div class="mb-3">
      <div class="row g-2">
        <div class="col-md-3">
          <label class="form-label">{{ 'THEME_SUCCESS' | translation }}</label>
          <div class="input-group">
            <input type="color" class="form-control form-control-color"
              [value]="tenant.portal.successColor || selectedPalette?.success || '#1e7e34'"
              (input)="setPortalColor('successColor', $any($event.target).value)" />
            <button class="btn btn-outline-secondary" type="button" [title]="'CLEAR' | translation"
              (click)="clearPortalColor('successColor')">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ 'THEME_WARNING' | translation }}</label>
          <div class="input-group">
            <input type="color" class="form-control form-control-color"
              [value]="tenant.portal.warningColor || selectedPalette?.warning || '#d39e00'"
              (input)="setPortalColor('warningColor', $any($event.target).value)" />
            <button class="btn btn-outline-secondary" type="button" [title]="'CLEAR' | translation"
              (click)="clearPortalColor('warningColor')">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ 'THEME_DANGER' | translation }}</label>
          <div class="input-group">
            <input type="color" class="form-control form-control-color"
              [value]="tenant.portal.dangerColor || selectedPalette?.danger || '#bd2130'"
              (input)="setPortalColor('dangerColor', $any($event.target).value)" />
            <button class="btn btn-outline-secondary" type="button" [title]="'CLEAR' | translation"
              (click)="clearPortalColor('dangerColor')">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ 'THEME_INFO' | translation }}</label>
          <div class="input-group">
            <input type="color" class="form-control form-control-color"
              [value]="tenant.portal.infoColor || selectedPalette?.info || '#117a8b'"
              (input)="setPortalColor('infoColor', $any($event.target).value)" />
            <button class="btn btn-outline-secondary" type="button" [title]="'CLEAR' | translation"
              (click)="clearPortalColor('infoColor')">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="form-text">{{ 'THEME_COLOR_OVERRIDES_HELP' | translation }}</div>
    </div>

    <label>{{ 'THEME_GRAPH_COLORS' | translation }}</label>
    <div class="mb-3">
      <div class="d-flex flex-wrap align-items-center gap-2">
        @for (color of graphColorList(); track $index) {
        <div class="graph-color-swatch" [style.background-color]="color">
          <label class="graph-color-swatch__edit" [title]="'EDIT' | translation">
            <i class="fa-solid fa-pen"></i>
            <input type="color" [value]="color"
              (change)="updateGraphColor($index, $any($event.target).value)" />
          </label>
          <button type="button" class="graph-color-swatch__remove" (click)="removeGraphColor($index)"
            [title]="'CLEAR' | translation">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        }
        <div class="graph-color-add">
          <input type="color" class="form-control form-control-color" [(ngModel)]="newGraphColor"
            [title]="'THEME_GRAPH_ADD' | translation" />
          <button type="button" class="btn btn-outline-secondary graph-color-add__btn"
            (click)="addGraphColor(newGraphColor)" [title]="'THEME_GRAPH_ADD' | translation">
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="form-text">{{ 'THEME_GRAPH_COLORS_HELP' | translation }}</div>
    </div>
    }

    @if (pageId === 'nav') {
    <div class="mb-3">
      <label>{{ 'PREFIX' | translation }}</label>
      <input type="text" class="form-control" #tenantprefix maxlength="4" (change)="validateFields()"
        [(ngModel)]="tenant.prefix" [ngClass]="{
              'is-invalid': !tenant.prefix || tenant.prefix.length < 4
            }" required />
    </div>

    <div class="mb-3">
      <label>{{ 'NAME' | translation }}</label>
      <input type="text" class="form-control" [(ngModel)]="tenant.name" (change)="validateFields()" [ngClass]="{
              'is-invalid': !tenant.name || tenant.name.length === 0
            }" required />
    </div>

    <div class="mb-3 form-check form-switch">
      <input class="form-check-input" type="checkbox" id="isActiveSwitch" [(ngModel)]="tenant.isActive" />
      <label class="form-check-label ms-2" for="isActiveSwitch">
        {{ (tenant.isActive ? 'TENANT_ACTIVE' : 'TENANT_INACTIVE') | translation }}
      </label>
    </div>

    <div class="mb-3">
      <label class="form-label">{{ 'LICENCE_ID' | translation }}</label>
      <div class="input-group">
        <input type="text" class="form-control" #tenantprefix [(ngModel)]="tenant.licenceId" (change)="validateFields()"
          [ngClass]="{ 'is-invalid': !validateLicenceId(tenant.licenceId) }" required />
      </div>
      <div class="form-text">{{ 'LICENCE_ID_HELP' | translation }}</div>
    </div>
    <div>
      <app-admin-connectivity-test [allowTest]="allowTest()" [tenantId]="tenant.id"
        [connectionType]="tenant.connectionType"></app-admin-connectivity-test>
      <tabset (change)="disableTest()">
        <tab [heading]="'USE_SOAP_SERVICE' | translation" [active]="tenant.connectionType === 0"
          (selectTab)="tenant.connectionType = 0">
          <div class="mt-3">
            <div class="mb-3">
              <label>{{ 'SERVICE_URL' | translation }}</label>
              <input type="text" class="form-control" [(ngModel)]="tenant.serviceUrl" />
            </div>

            <div class="mb-3">
              <label>{{ 'SERVICE_DOMAIN' | translation }}</label>
              <input type="text" class="form-control" [(ngModel)]="tenant.serviceDomain" />
            </div>

            <div class="mb-3">
              <label>{{ 'SERVICE_USERNAME' | translation }}</label>
              <input type="search" class="form-control" [(ngModel)]="tenant.serviceUsername" />
            </div>

            <label>{{ 'SERVICE_PASSWORD' | translation }}</label>
            <div class="mb-3 input-group">
              <input autocomplete="new-password" type="password" class="form-control"
                [(ngModel)]="tenant.servicePassword" />

              <button class="btn btn-outline-success" (click)="updateTenantServicePassword()" type="button">
                <i class="fa-solid fa-floppy-disk"></i>
              </button>
            </div>
          </div>
        </tab>
        <tab [heading]="'USE_REST_BASIC' | translation" [active]="tenant.connectionType === 1"
          (selectTab)="tenant.connectionType = 1">
          <div class="mt-3">
            <div class="mb-3">
              <label>{{ 'REST_BASIC_AUTH_URL' | translation }}</label>
              <input type="text" class="form-control" [(ngModel)]="tenant.restBasicAuthUrl" />
            </div>

            <div class="mb-3">
              <label>{{ 'REST_BASIC_AUTH_USERNAME' | translation }}</label>
              <input type="search" class="form-control" [(ngModel)]="tenant.restBasicAuthUsername" />
            </div>

            <label>{{ 'REST_BASIC_AUTH_PASSWORD' | translation }}</label>
            <div class="mb-3 input-group">
              <input autocomplete="new-password" type="password" class="form-control"
                [(ngModel)]="tenant.restBasicAuthPassword" />

              <button class="btn btn-outline-success" (click)="updateTenantRestBasicAuthPassword()" type="button">
                <i class="fa-solid fa-floppy-disk"></i>
              </button>
            </div>
          </div>
        </tab>
        <tab [heading]="'USE_REST_OAUTH' | translation" [active]="tenant.connectionType === 2"
          (selectTab)="tenant.connectionType = 2">
          <div class="mt-3">
            <div class="mb-3">
              <label>{{ 'REST_OAUTH_URL' | translation }}</label>
              <input type="text" class="form-control" [(ngModel)]="tenant.restOAuthUrl" />
            </div>

            <div class="mb-3">
              <label>{{ 'REST_OAUTH_ENDPOINT' | translation }}</label>
              <input type="text" class="form-control" [(ngModel)]="tenant.restOAuthEndpoint" />
            </div>

            <div class="mb-3">
              <label>{{ 'REST_OAUTH_SCOPE' | translation }}</label>
              <input type="search" class="form-control" [(ngModel)]="tenant.restOAuthScope" />
            </div>

            <div class="mb-3">
              <label>{{ 'REST_OAUTH_GRANT_TYPE' | translation }}</label>
              <input type="search" class="form-control" [(ngModel)]="tenant.restOAuthGrantType" />
            </div>

            <div class="mb-3">
              <label>{{ 'REST_OAUTH_CLIENT_ID' | translation }}</label>
              <input type="search" class="form-control" [(ngModel)]="tenant.restOAuthClientId" />
            </div>

            <label>{{ 'REST_OAUTH_CLIENT_SECRET' | translation }}</label>
            <div class="mb-3 input-group">
              <input autocomplete="new-password" type="password" class="form-control"
                [(ngModel)]="tenant.restOAuthClientSecret" />
              <button class="btn btn-outline-success" (click)="updateTenantRestOAuthSecret()" type="button">
                <i class="fa-solid fa-floppy-disk"></i>
              </button>
            </div>
          </div>
        </tab>
        @if (environment.environment === 'local') {
        <tab heading="File" [active]="tenant.connectionType === 3" (selectTab)="tenant.connectionType = 3">
          <div class="mt-3">
            <label>Tenant will only work with files on the server</label>
          </div>
        </tab>
        }
      </tabset>

    </div>

    <hr />

    <div class="mb-3">
      <label>{{ 'ID' | translation }}</label>
      <input disabled type="text" class="form-control" [(ngModel)]="tenant.id" />
    </div>

    <div class="row g-2">
      <div class="col-md">
        <div class="">
          <label>{{ 'DATE_CREATED' | translation }}</label>
          <input disabled type="text" class="form-control" [value]="tenant.dateCreated | moment" />
        </div>
      </div>
      <div class="col-md">
        <div class="">
          <label>{{ 'DATE_UPDATED' | translation }}</label>
          <input disabled type="text" class="form-control" [value]="tenant.dateUpdated | moment" />
        </div>
      </div>
    </div>
    }
  </div>

  <div class="modal-footer">
    @if (tenant.id) {
    <button [disabled]="!allowSave" type="button" class="btn btn-default" (click)="updateTenant()">
      {{ 'SAVE' | translation }}
      <i class="mx-2 fa-solid fa-floppy-disk"></i>
    </button>
    } @else {
    <button [disabled]="!allowSave" type="button" class="btn btn-default" (click)="addTenant()">
      {{ 'CREATE' | translation }}<i class="mx-2 fa-solid fa-paper-plane-top"></i>
    </button>
    }
  </div>
</div>
}
